import type { Application } from '@src/@types/app';
import { Experiments } from '@src/constants/abTest';
import { DEFAULT_PRELOADED_LIMIT, FILTERS_NAMES } from '@src/constants/filters';
import type { ListKeys } from '@src/constants/microcredits';
import { getUserPhoneForChecker } from '@src/helpers/getUserPhoneForChecker';
import { CookieKey } from '@src/modules/cookie';
// eslint-disable-next-line import/no-deprecated
import { fetchOffers } from '@src/reducers/microcredits';
import { isServer } from '@src/utils';
import { getCookieFromServerOrClient } from '@src/utils/getCookieFromServerOrClient';

import { getPageListQuery } from './getPageListQuery';

interface IListParams {
  key: ListKeys;
  defaultFiltersMode: string;
}

export const getPageListData = async (ctx: Application.ReduxNextPageContext, listParams: IListParams) => {
  const {
    store: { dispatch },
  } = ctx;
  const { key, defaultFiltersMode } = listParams;

  const isSeaExcludeFeatureExperiment =
    ctx.store.getState()?.metadata?.abTestingInfo?.experiments?.[Experiments.EXCLUDE_FULLDEAL_OFFERS] === '1';

  const filterParams = getFilterParams(ctx, { isSeaExcludeFeatureExperiment });

  const pageListQuery = getPageListQuery({ ctx, defaultFiltersMode });

  await dispatch(
    fetchOffers({
      key,
      query: pageListQuery,
      params: filterParams,
      ...(isServer && { preloadedLimit: DEFAULT_PRELOADED_LIMIT }),
    }),
  );
};

function getFilterParams(
  ctx: Application.ReduxNextPageContext,
  experiments: { isSeaExcludeFeatureExperiment: boolean },
) {
  const { hasUtmLabel } = ctx.store.getState().route;

  const clientId = getCookieFromServerOrClient(ctx, CookieKey._ym_uid);

  return {
    [FILTERS_NAMES.LOCATION]: ctx.params.locationRoute,
    [FILTERS_NAMES.METADATA]: true,
    [FILTERS_NAMES.ROUTE]: { asPath: ctx.asPath ?? '', query: ctx.query ?? {} },
    ...(!hasUtmLabel && {
      [FILTERS_NAMES.ADS_ONLY]: true,
      [FILTERS_NAMES.HAS_OFFERS_DUPLICATE]: true,
      ...(experiments.isSeaExcludeFeatureExperiment && {
        [FILTERS_NAMES.EXPERIMENT]: Experiments.EXCLUDE_FULLDEAL_OFFERS,
      }),
    }),
    ...(Boolean(clientId) && {
      [FILTERS_NAMES.CLIENT_ID]: clientId,
    }),
    ...getUserPhoneForChecker(ctx),
  };
}
